import { render, staticRenderFns } from "./ui-range.vue?vue&type=template&id=ca5cd3f8&"
import script from "./ui-range.vue?vue&type=script&lang=js&"
export * from "./ui-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports